module.exports = __webpack_public_path__ + "static/img/Concert-of-NewMusic-LivingTheaterProgram_1960.2a29889.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/Concert-of-NewMusic-LivingTheaterProgram_1960.jpg
// module id = H8HW
// module chunks = 0